// // 测试环境
// export const ContentServiceBasePath = "http://127.0.0.1:8000"
// export const AiServiceBasePath = "http://127.0.0.1:8001"
// export const UserServiceBasePath = "http://127.0.0.1:8002"




// 生产环境
export const ContentServiceBasePath = "https://www.aifastlearn.cn/content-service"  //对应端 9004
export const AiServiceBasePath = "https://www.aifastlearn.cn/ai-service"           //对应端 9005
export const UserServiceBasePath = "https://www.aifastlearn.cn/user-service"       //对应端 9006

export const  WssUrl = 'wss://www.aifastlearn.cn/ai-service/v1/ws/aichat' 